import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

export const SP_QUOTE_LOGS_COLLECTION = 'spQuoteLogs';

/** Stable fingerprint so we don't re-log the same settled quote. */
export function buildSpQuoteLogFingerprint({
  quantity,
  cogs,
  decorationType,
  locations,
  selectedStyle,
  garmentQuery,
  totalsBand,
  selectedPerPiece,
  jobFee,
  taxExempt,
  askPerPiece,
  floorPerPiece,
  grandTotal,
}) {
  return JSON.stringify({
    quantity: Number(quantity) || 0,
    cogs: Number(cogs) || 0,
    decorationType,
    locations,
    selectedStyle: selectedStyle || '',
    garmentQuery: (garmentQuery || '').trim().toUpperCase(),
    totalsBand,
    selectedPerPiece: selectedPerPiece != null ? Number(selectedPerPiece) : null,
    jobFee: Number(jobFee) || 0,
    taxExempt: !!taxExempt,
    askPerPiece: askPerPiece != null ? Number(askPerPiece) : null,
    floorPerPiece: floorPerPiece != null ? Number(floorPerPiece) : null,
    grandTotal: grandTotal != null ? Number(grandTotal) : null,
  });
}

export function shouldLogSpQuote({ quantity, quote }) {
  const qty = Number(quantity) || 0;
  if (qty <= 0) return false;
  if (!quote?.bands?.yellow?.perPiece && !quote?.bands?.green?.perPiece) return false;
  return true;
}

/**
 * Persist a settled SP Quote snapshot for usage tracking.
 * Safe to call from the public /sp-quote page.
 */
export async function logSpQuoteUsage(payload) {
  const doc = {
    quantity: Number(payload.quantity) || 0,
    cogs: Number(payload.cogs) || 0,
    decorationType: payload.decorationType || 'screen',
    locations: payload.locations || null,
    selectedStyle: payload.selectedStyle || '',
    garmentQuery: (payload.garmentQuery || '').trim(),
    // 'green' (at ask) | 'yellow' (at floor) | 'custom' (slider in between)
    totalsBand: payload.totalsBand || 'green',
    selectedPerPiece: payload.selectedPerPiece ?? null,
    jobFee: Number(payload.jobFee) || 0,
    taxExempt: !!payload.taxExempt,
    minutes: payload.minutes ?? null,
    askPerPiece: payload.askPerPiece ?? null,
    floorPerPiece: payload.floorPerPiece ?? null,
    askTotal: payload.askTotal ?? null,
    floorTotal: payload.floorTotal ?? null,
    merchandiseSubtotal: payload.merchandiseSubtotal ?? null,
    taxAmount: payload.taxAmount ?? null,
    grandTotal: payload.grandTotal ?? null,
    netIncome: payload.netIncome ?? null,
    greenUnavailable: !!payload.greenUnavailable,
    fingerprint: payload.fingerprint || null,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    createdAt: serverTimestamp(),
  };

  const ref = await addDoc(collection(db, SP_QUOTE_LOGS_COLLECTION), doc);
  return ref.id;
}
